module.exports = __webpack_public_path__ + "img/cov-liveinbali.43dce38c.jpg";